import Section from './Section.view';

export default Section;
